import React from "react";
import { Card, Badge, Progress } from "flowbite-react";
import { FiAlertTriangle, FiXCircle } from "react-icons/fi";
import { FaCheckCircle } from "react-icons/fa";
import { HiInformationCircle } from "react-icons/hi";

const AnaliseDeCredito = ({ resultado }) => {
  const {
    scoreFinal,
    codigoClassificacaoRisco,
    classificacaoRisco,
    observacoesPositivas,
    observacoesNegativas,
    recomendacao,
  } = resultado;

  const cores = {
    BAIXO: "green",
    MÉDIO: "yellow",
    ALTO: "orange",
    ALTÍSSIMO: "red",
  };

  const icones = {
    BAIXO: <FaCheckCircle className="text-green-500 w-8 h-8" />,
    MÉDIO: <FiAlertTriangle className="text-yellow-500 w-8 h-8" />,
    ALTO: <FiAlertTriangle className="text-red-500 w-8 h-8" />,
    ALTÍSSIMO: <FiXCircle className="text-red-500 w-8 h-8" />,
  };

  const estilosRecomendacao = {
    BAIXO: {
      bg: "bg-green-50",
      border: "border-green-300",
      text: "text-green-800",
      icon: "text-green-500",
    },
    MÉDIO: {
      bg: "bg-yellow-50",
      border: "border-yellow-300",
      text: "text-yellow-800",
      icon: "text-yellow-500",
    },
    ALTO: {
      bg: "bg-red-50",
      border: "border-red-300",
      text: "text-red-800",
      icon: "text-red-500",
    },
    ALTÍSSIMO: {
      bg: "bg-red-50",
      border: "border-red-300",
      text: "text-red-800",
      icon: "text-red-500",
    },
  };

  const cor =
    estilosRecomendacao[classificacaoRisco] || estilosRecomendacao["MÉDIO"];

  return (
    <div>
      <div className="rounded-2xl shadow-sm border border-gray-300 p-3">
        <h2 className="text-2xl font-bold mb-4">
          Análise de Crédito Completa com IA
        </h2>

        <div className="flex items-center gap-4 mb-6">
          {icones[classificacaoRisco]}
          <div>
            <p className="text-sm text-gray-500">Classificação de risco:</p>
            <p
              className={`font-bold text-lg text-${cores[classificacaoRisco]}-600`}
            >
              {classificacaoRisco}
            </p>
          </div>
        </div>

        <div className="mb-6">
          <p className="text-sm text-gray-500 mb-1">Score calculado:</p>
          <Progress
            progress={scoreFinal / 10}
            color={cores[classificacaoRisco]}
            size="xl"
          />
          <p className="mt-1 font-bold text-center">{scoreFinal} / 1000</p>
        </div>

        {/* Observações Positivas */}
        {observacoesPositivas?.length > 0 && (
          <div className="mb-6">
            <p className="text-sm text-gray-500 mb-1">Fatores Positivos:</p>
            <div className="space-y-2">
              {observacoesPositivas.map((obs, index) => (
                <div
                  key={index}
                  className="flex items-start gap-2 bg-green-50 p-3 rounded-md border border-green-200 shadow-sm"
                >
                  <div className="text-green-600">
                    <FaCheckCircle className="w-5 h-5" />
                  </div>
                  <p className="text-sm text-gray-700">{obs}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Observações Negativas */}
        {observacoesNegativas?.length > 0 && (
          <div className="mb-6">
            <p className="text-sm text-gray-500 mb-1">Fatores de Risco:</p>
            <div className="space-y-2">
              {observacoesNegativas.map((obs, index) => (
                <div
                  key={index}
                  className="flex items-start gap-2 bg-red-50 p-3 rounded-md border border-red-200 shadow-sm"
                >
                  <div className="text-red-600">
                    <FiXCircle className="w-5 h-5" />
                  </div>
                  <p className="text-sm text-gray-700">{obs}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="mb-4">
          <p className="text-sm text-gray-500 mb-1">Recomendação:</p>
          <div
            className={`flex items-start gap-3 p-4 rounded-lg shadow-sm border ${cor.border} ${cor.bg}`}
          >
            <div className={`${cor.icon}`}>
              <HiInformationCircle className="w-6 h-6" />
            </div>
            <p className={`text-base font-semibold leading-snug ${cor.text}`}>
              {recomendacao}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnaliseDeCredito;
